import { SVGProps } from '@components/Icon/types';

export const Experience = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4347 3.71733C18.855 3.71733 20 4.86231 20 6.28267V17.4347C20 18.855 18.855 20 17.4347 20H2.56534C1.14498 20 0 18.855 0 17.4347V6.28267C0 4.86231 1.14498 3.71733 2.56534 3.71733H17.4347ZM18.5866 10.6418C16.2365 11.8511 13.7007 12.5375 11.1404 12.6951V13.4695C11.1404 14.0991 10.6296 14.6099 10 14.6099C9.37041 14.6099 8.85963 14.0991 8.85963 13.4695V12.6951C6.29928 12.5375 3.76347 11.8511 1.41336 10.6418V17.4347C1.41336 18.0774 1.92259 18.5866 2.56534 18.5866H17.4347C18.0774 18.5866 18.5866 18.0774 18.5866 17.4347V10.6418ZM2.56534 5.13069C1.92259 5.13069 1.41336 5.63991 1.41336 6.28267V9.03872C6.73804 12.0782 13.262 12.0782 18.5866 9.03872V6.28267C18.5866 5.63991 18.0774 5.13069 17.4347 5.13069H2.56534Z"
        fill={fill}
      />
      <path
        d="M11.4869 0C12.9073 0 14.0523 1.14498 14.0523 2.56534C14.0523 2.96344 13.7437 3.27202 13.3456 3.27202C12.9475 3.27202 12.6389 2.96344 12.6389 2.56534C12.6389 1.92259 12.1297 1.41336 11.4869 1.41336H8.51307C7.87031 1.41336 7.36108 1.92259 7.36108 2.56534C7.36108 2.96344 7.0525 3.27202 6.6544 3.27202C6.25631 3.27202 5.94773 2.96344 5.94773 2.56534C5.94773 1.14498 7.09271 0 8.51307 0H11.4869Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'experience';
